import React from "react";
import CountyDrivingLessonsTemplate from "../../components/driving-lessons/CountyDrivingLessonsTemplate";
import { commonCourses, commonDisclaimer, countiesData } from "../../data/drivingLessonsData";

// Fallback content if needed, but we'll try to stick to the data file
const defaultWhyMetroContent = (
    <>
        <p className="lh-lg" style={{ color: "#fff" }}>
            In order to attain our goal of creating a safer world, we strongly believe
            the first step is to develop safe driving habits from the beginning.
            Metro Driving School’s commitment to developing safe driver’s, starts by
            providing the best driving lesson available. All our instructors are
            experienced and go through a rigorous certification process. Our
            vehicles are all newer models, dual controlled, and continually
            inspected to ensure they meet our standards of excellence.
        </p>
        <p className="lh-lg" style={{ color: "#fff" }}>
            By completing driving lessons with Metro, not only will you be provided
            the opportunity to take the DMV exam with the same vehicle you completed
            your lessons with, you may also qualify for a significant insurance
            discount. Metro Driving School is recognized state-wide for its value
            and commitment to safety. Therefore, by completing one of our Programs,
            most major insurance companies will provide you with a better insurance
            premium for completing our drivers education program.
        </p>
        <p className="lh-lg" style={{ color: "#fff" }}>
            We stand behind every program and on the off chance you are not
            completely satisfied with your experience at Metro Traffic School,
            please give us a call so we can ensure all future experiences are
            nothing short of excellent . Our dedicated customer services
            representatives will be with you every step of the way to ensure you not
            only obtain the driving experience you deserve, but also are one step
            closer to passing your driving test on the first try and becoming a
            better defensive driver.
        </p>
    </>
);

const GenericCountyDrivingLessons = ({ countyKey }) => {
    const data = countiesData[countyKey];

    if (!data) {
        return <div className="text-white text-center py-5">County data not found.</div>;
    }

    return (
        <CountyDrivingLessonsTemplate
            heroImage={data.image}
            title={data.title}
            subTitle={data.phone}
            courses={commonCourses}
            disclaimerText={commonDisclaimer}
            whyMetroContent={defaultWhyMetroContent}
        />
    );
};

export default GenericCountyDrivingLessons;
